import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import SyllabusPatternTbl from './syllabusPatternTbl';
import { getPatternListV1Svc, getExamSyllabusList, getSyllabusClassesList, saveExamQusPattern } from './questionPaperSvc';

function ExamPatternSlider(props) {
    const { examId, exam, syllabusObj, syllabusId, updateKey, closeSlider } = props;

    const [editLoader, setEditLoader] = useState("none");
    const [editOpacity, setEditOpacity] = useState(1);
    const [lstPattern, setLstPattern] = useState([]);
    const [lstClasses, setLstClasses] = useState([]);
    const [durationHh, setDurationHh] = useState(0);
    const [durationMm, setDurationMm] = useState(0);
    const [noOfSets,  setNoOfSets] = useState(0); 
    const [patternId, setPatternId] = useState(0);

    useEffect(() => {
        // console.log("ExamPatternSlider called");
        // console.log("exam", exam);
        // console.log("examId", examId);
        // console.log("syllabusObj", syllabusObj);
        // console.log("syllabusId", syllabusId);
        getListPattern();
        getClassList(syllabusId);
        // Math.floor zaroori hai � warna (jaise 10 min ke liye) Hh = 0.1666 (decimal) aata hai,
        // aur Save karte waqt duration double ho jaata hai (60*0.1666 + 10 � 20, 10 nahi).
        setDurationHh(Math.floor(syllabusObj.duration / 60));
        setDurationMm(syllabusObj.duration % 60);
        setNoOfSets(syllabusObj.noOfSets);
        setPatternId(syllabusObj.patternId);
    }, [syllabusId, syllabusObj]);

    const getListPattern = () => {
        // console.log("getListPattern called");
        setEditLoader("block");
        setEditOpacity(0.5);
        getPatternListV1Svc(syllabusId, patternListResponse);
    }

    const patternListResponse = (data) => {
        // console.log("patternListResponse called");
        if (data.status === "Success") {
            setLstPattern(data.lstPattern);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }

    const getClassList = (pSyllabusId) => {
        // console.log("getClassList called");
        setEditLoader("block");
        setEditOpacity(0.5);
        getSyllabusClassesList(pSyllabusId, classListResponse);
    }

    const classListResponse = (data) => {
        // console.log("classListResponse called");
        if (data.status === "Success") {
            setLstClasses(data.lstClasses);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }

    const applyPattern = () => {
        if (!patternId) {
            toast.warn("please select a pattern");
            return;
        }
        if (!durationHh && !durationMm) {
            toast.warn("please enter duration of exam");
            return;
        }
        if (!noOfSets) {
            toast.warn("please enter no of sets");
            return;
        }
        // console.log("applyPattern called");
        const RQApplyPattern = {
            syllabusId,
            examId,
            subjectId: syllabusObj.subId,
            patternId,
            duration: 60 * Number(durationHh) + Number(durationMm),
            noOfSets: Number(noOfSets)
        }
        setEditLoader("block");
        setEditOpacity(0.5);
        saveExamQusPattern(RQApplyPattern, applyPatternResponse);
    }

    const applyPatternResponse = (data) => {
        // console.log("applyPatternResponse called");
        if (data.status === "Success") {
            toast.success(data.message);
            updateKey();
            closeSlider();
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    return (
        <div >
            <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '58%', top: '45%', display: editLoader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="col-md-12 col-xs-12 col-centered padding-remove "
                style={{
                    cursor: (editLoader === "none") ? 'pointer' : 'none',
                    pointerEvents: (editLoader === "none") ? 'auto' : 'none',
                    opacity: editOpacity
                }}>
            </div>
            <div className="col-sm-12 col-md-12 padding-remove" style={{ width: '94%', margin: '3%', background: '#fff' }}>
                <div
                    className="col-md-12 col-xs-12 col-centered padding-remove"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "20px",
                        padding: "10px 4px",
                        marginBottom: "10px",
                        borderBottom: "1px solid #eee",
                    }}
                >
                    <div style={{ fontSize: "15px", fontWeight: 600, color: "#333" }}>{exam.exam}</div>
                    <div style={{ fontSize: "15px", color: "#333" }}>{syllabusObj.sub}</div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        {lstClasses
                            ? lstClasses.map((cls, index) => (
                                <div
                                    key={index}
                                    style={{
                                        fontSize: "13px",
                                        border: "1px solid #ccc",
                                        borderRadius: "20px",
                                        padding: "3px 12px",
                                    }}
                                >
                                    {cls.cls} - {cls.csvSection}
                                </div>
                            ))
                            : null}
                    </div>
                </div>
                <div className="col-md-12 col-xs-12 col-centered padding-remove " style={{ border: '1px solid #ccc', borderRadius: 10 }}>
                    <form id="editSubjectAllocationForm" className="form form-horizontal" style={{ height: "60vh", minHeight: "350px", overflowX: 'hidden', padding: "20px 20px 5px 20px" }}>
                        <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                            Please select a pattern
                        </div>
                        <SyllabusPatternTbl
                            lstPattern={lstPattern}
                            patternId={patternId}
                            setPatternId={setPatternId}
                        />
                        <div className="form-group col-md-12 padding-remove" style={{ display: "flex", alignItems: "center" }}>
                            <label
                                className="control-label col-md-3 col-xs-6"
                                style={{ padding: "7px 10px 0 0", whiteSpace: "nowrap" }}
                            >
                                Duration:
                            </label>
                            <div style={{ display: "flex", alignItems: "center", gap: "30px", paddingLeft: "15px" }}>
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={durationHh}
                                        onChange={(e) => setDurationHh(e.target.value)}
                                        style={{
                                            border: "none",
                                            borderRadius: 0,
                                            backgroundColor: "",
                                            boxShadow: "none",
                                            borderBottom: "1px solid #000",
                                            outline: "none",
                                            width: "50px",
                                            textAlign: "right",
                                        }}
                                    />
                                    <span style={{ position: "absolute", top: "50%", left: "60px", transform: "translateY(-50%)" }}>hrs</span>
                                </div>
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={durationMm}
                                        onChange={(e) => setDurationMm(e.target.value)}
                                        style={{
                                            border: "none",
                                            borderRadius: 0,
                                            backgroundColor: "",
                                            boxShadow: "none",
                                            borderBottom: "1px solid #000",
                                            outline: "none",
                                            width: "50px",
                                            textAlign: "right",
                                        }}
                                    />
                                    <span style={{ position: "absolute", top: "50%", left: "60px", transform: "translateY(-50%)" }}>mins</span>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-12 padding-remove">
                            <label className="control-label col-md-3 col-xs-6 " style={{ padding: "7px 10px 0 0" }}>
                                Sets:
                            </label>
                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <input
                                    type="number"
                                    className="form-control"
                                    value={noOfSets}
                                    onChange={(e) => setNoOfSets(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-sm-4 padding-remove" style={{ height: "50px", marginTop: "10px" }}>
                            <div className="col-sm-3 col-md-3 padding-remove pull-right">
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => applyPattern()}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ExamPatternSlider;